import { useTranslation } from "react-i18next"
import { ReassignUserTabs } from "../enums"
import { ListTabItem } from "../../../../../../../components/customeTab/types"

export const useTabList = (): ListTabItem[] => {
    const { t } = useTranslation()
    return [
        {
            id: ReassignUserTabs.REASSIGN,
            label: t('reportFolio.tabList.reassign'),
            value: ReassignUserTabs.REASSIGN
        },
        {
            id: ReassignUserTabs.TRACKING,
            label: t('reportFolio.tabList.tracking'),
            value: ReassignUserTabs.TRACKING
        },
    ]
}